/**
* @name: YRotateIcon.vue
* @description: 可旋转角度的图标
* @author: 温永江
* @create: 2020/07/22 15:47:03
* @update: 2020/07/22 15:47:03
*/

export default {
  props: {
    size: {
      type: [String, Number],
      default: '14'
    },
    color: String,
    name: {
      type: String,
      default: 'k-icon-arrow-right'
    },
    weight: Boolean,

    deg: {
      type: [Number, String],
      default: 90
    },
    rotate: Boolean
  },
  computed: {
    cDeg() {
      const d = parseFloat(this.deg);
      if (isNaN(d) || !d) {
        return '0deg';
      }
      return `${d}deg`;
    }
  },
  render() {
    let p = {
      props: {
        size: this.size,
        color: this.color,
        name: this.name,
        weight: this.weight
      },
      on: this.$listeners,
      style: {
        display: 'inline-block',
        transition: 'transform .25s'
      }
    };
    let style = {
      transform: `rotate(${this.cDeg})`
    };

    if (this.rotate) {
      p.style = { ...p.style, ...style };
    }

    return <k-icon {...p} />;
  }
};
